import { SEARCH_RESULT_LOADED } from "./actions";

const defaultState = {
  searchMovies: []
};

export const searchReducer = (state = defaultState, action) => {
  switch (action.type) {
    case SEARCH_RESULT_LOADED:
      return {
        searchMovies: action.payload
      };

    default:
      return state;
  }
};
